import { render, staticRenderFns } from "./Reporting.vue?vue&type=template&id=6ca64a5f&scoped=true&"
import script from "./Reporting.vue?vue&type=script&lang=js&"
export * from "./Reporting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca64a5f",
  null
  
)

export default component.exports